import React, { FC } from 'react';

import clsx from 'clsx';

import { Recipe } from '@domains/recipes';

import { RecipeCard } from '@components/common/RecipeCard/RecipeCard';

import styles from './RecipesGrid.module.scss';

export type RecipesGridProps = {
    recipes: Recipe[];
    className?: string;
};

export const RecipesGrid: FC<RecipesGridProps> = (props) => {
    const { recipes, className } = props;

    return (
        <div className={clsx(styles.root, className)}>
            {recipes.map((recipe) => (
                <RecipeCard key={recipe.id} recipe={recipe} />
            ))}
        </div>
    );
};
